import { Component, ReactNode } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorLogin } from "../../components/ErrorLogin/ErrorLogin";
import { SuccessfulLogin } from "../../components/SuccessfulLogin/SuccessfulLogin";
import ListConnectionsContainer from "../ListConnectionsContainer/ListConnectionsContainer";

export class AppContainer extends Component<{}, {}> {
  render(): ReactNode {
    return (
      <div className={"app-container"}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ListConnectionsContainer />}></Route>
            <Route
              path="list-connections"
              element={<ListConnectionsContainer />}
            />
            <Route
              path="new-connection"
              element={<ListConnectionsContainer />}
            />
            <Route
              path="new-connection/success"
              element={<SuccessfulLogin />}
            />
            <Route path="new-connection/error" element={<ErrorLogin />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }
}
